<template>
  <div class="action" :class="{ mobile: isMobile }">
    <h6 v-if="!(isEditingAlert && isMobile)">
      <span v-if="isMobile" @click="backToIndexPage">
        <fa icon="chevron-left" class="icon"></fa>
      </span>
      Action
    </h6>
    <p>
      Select the action that will happen when the system triggers the alert.
    </p>
    <span v-if="isMobile" class="separate-line"></span>
    <div class="notification">
      <Notification
        type="info"
        title="Currently, only you can receive alerts by email."
      >
        <span>
          We are working on improvements for future releases so you can add
          additional email addresses and actions.
        </span>
      </Notification>
    </div>
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text" id="basic-addon1">
          <span>
            Send email to:
          </span>
          <fa icon="chevron-down" class="icon"></fa>
        </div>
      </div>
      <input
        type="email"
        class="form-control"
        placeholder="Username"
        aria-label="Username"
        aria-describedby="basic-addon1"
        v-model="email"
        disabled
      />
    </div>
    <!-- Remove it temporarily as we will implement email change later -->
    <!-- <p v-show="!isValidEmail" class="text-danger warning">
      Please input a valid email.
    </p> -->
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Notification from '../../ui/Notification.vue';

// Remove it temporarily as we will implement email change later
// import { checkIsValidEmail } from '../../../utils/common';

export default {
  name: 'Action',
  components: { Notification },
  props: {
    prevEmail: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState('alertsSuspiciousTrafficStore', ['isEditingAlert']),
    ...mapGetters(['isMobile']),
    email: {
      get() {
        return this.prevEmail;
      },
      set(val) {
        this.$emit('updateEmail', val);
      }
    }
    /*
    // Remove it temporarily as we will implement email change later
    isValidEmail() {
      return checkIsValidEmail(this.email);
    } 
    */
  },
  methods: {
    backToIndexPage() {
      this.$emit('backToIndexPage');
    }
  }
};
</script>

<style lang="scss" scoped>
.action {
  padding: 2rem 1.5rem;
  overflow-y: scroll;
  overflow-x: hidden;

  & > p {
    line-height: 1.5rem;
  }
}
h6 {
  font-weight: 600;

  & > span {
    font-size: 1.2rem;
    padding: 0.5rem 1rem;
    margin-left: -1rem;
    vertical-align: bottom;
    color: $text-light-blue;
  }
}

.separate-line {
  @include separate-line;
}

.input-group {
  &-prepend {
    width: 30%;
    min-width: 10rem;
  }
  &-text {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    width: 100%;

    .icon {
      color: $icon-grey;
    }
  }

  & > input {
    max-width: 30rem;
  }
}

p.warning {
  margin-top: 0.2rem;
}

.notification {
  margin-bottom: 2rem;
}

.mobile {
  padding: 1rem;

  h6 {
    margin-bottom: 1rem;
  }

  .input-group {
    display: flex;
    flex-direction: column;

    .input-group-prepend {
      width: 100%;
      margin-bottom: 1rem;
    }

    .form-control {
      width: 100%;
      max-width: none;
    }
  }
}
</style>
